<h2 mat-dialog-title>Filtros de Requerimento</h2>
<div mat-dialog-content>
  <form [formGroup]="requirementFilterForm">
    <!-- Campo de Situação no Requerimento -->
    <mat-form-field appearance="outline">
      <mat-label>Situação no Requerimento</mat-label>
      <mat-select formControlName="situacaoRequerimento">
        <mat-option *ngFor="let situacao of situacoes" [value]="situacao">
          {{ situacao }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Campo de Tipo de Requerimento -->
    <mat-radio-group formControlName="tipoRequerimento">
      <mat-radio-button value="Pessoa física">Pessoa Física (CPF)</mat-radio-button>
      <mat-radio-button value="Pessoa jurídica">Pessoa Jurídica (CNPJ)</mat-radio-button>
    </mat-radio-group>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="applyFilters()">Aplicar</button>
  <button mat-raised-button color="warn" (click)="clearFilters()">Limpar</button>
</div>